import { render, staticRenderFns } from "./ClassificationList.vue?vue&type=template&id=fb9337fe&scoped=true"
import script from "./ClassificationList.vue?vue&type=script&lang=js"
export * from "./ClassificationList.vue?vue&type=script&lang=js"
import style0 from "./ClassificationList.vue?vue&type=style&index=0&id=fb9337fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9337fe",
  null
  
)

export default component.exports